import {
  SET_SEARCH_KEY,
  CLEAR_SEARCH_KEY,
  SET_FILTER_COUNT,
  SET_FILTER_VALUES,
  FETCH_SEARCH_USER_ERROR,
  FETCH_SEARCH_USER_START,
  FETCH_SEARCH_USER_SUCCESS,
  APPLY_FILTER,
} from "./ActionConstant";

export function applyFilter () {
  return {
    type: APPLY_FILTER,
  }
}

export function setSearchKey (data) {
  return {
    type: SET_SEARCH_KEY,
    data,
  }
};

export function clearSearchKey () {
  return {
    type: CLEAR_SEARCH_KEY
  }
}

export function setFilterCount (data) {
  return {
    type: SET_FILTER_COUNT,
    data
  };
};

export function setFilterValues (data) {
  return {
    type: SET_FILTER_VALUES,
    data,
  }
}

export function fetchSearchUserStart(data) {
  return {
    type: FETCH_SEARCH_USER_START,
    data,
  };
}

export function fetchSearchUserSuccess(data) {
  return {
    type: FETCH_SEARCH_USER_SUCCESS,
    data,
  };
}

export function fetchSearchUserError(error) {
  return {
    type: FETCH_SEARCH_USER_ERROR,
    error,
  };
}
